import useUploadState from 'FeatureModules/Document/hooks/useUploadState';
import { useLogEvent } from 'hooks/useLogEvent';
import partition from 'lodash/partition';
import { useApolloClient } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from 'graphql/secure/fragments/document.fragments';

function useDocumentUploadActions() {
  const { logEvent } = useLogEvent();
  const { addFiles } = useUploadState();
  const client = useApolloClient();
  const MAX_MB = 25;

  const checkFileSize = ({ size }) => {
    return size < MAX_MB * 1000000;
  };

  const onDrop = (acceptedFiles, fileRejections, additionalProperties) => {
    logEvent('UPLOAD_DOCUMENT');
    const [checkedAcceptedFiles, rejectedAcceptedFiles] = partition(acceptedFiles, checkFileSize);

    const rejectedFiles = fileRejections.map(({ file }) => ({
      error: 'Invalid file type',
      file,
    }));

    const rejected = rejectedAcceptedFiles.map(file => ({
      error: 'File size too large',
      file,
    }));

    const finalAcceptedFiles = checkedAcceptedFiles.map(file => ({
      file,
      itemType: 'document',
    }));

    addFiles(finalAcceptedFiles, [...rejectedFiles, ...rejected], additionalProperties);
  };

  const getSelectedDocuments = selectedIds => {
    return selectedIds.map(id =>
      client.readFragment({
        fragment: DOCUMENT_FRAGMENT,
        id: `Document:${id}`,
        fragmentName: 'documentValues',
      })
    );
  };

  return {
    onDrop,
    getSelectedDocuments,
    maxSize: MAX_MB,
  };
}

export default useDocumentUploadActions;
